import {
  getLocalizedDateFilter,
  getLocalizedOrderStatus,
  getLocalizedSorting,
} from '../translations/default'

export const OrderFilter = {
  brenntagOrderNumber: 'filter[brenntagOrderNumber.icontains]',
  customerId: 'filter[customerContext.id.equals]',
  customerName: 'filter[customerContext.customerName.icontains]',
  customerNumber: 'filter[customerContext.customerNumber.icontains]',
  customerPONumber: 'filter[purchaseOrderNumber.icontains]',
  deliveryDateGreaterEqual: 'filter[requestedDeliveryDate.gte]',
  deliveryDateLessEqual: 'filter[requestedDeliveryDate.lte]',
  myOrders: 'filter[user.id.equals]',
  orderDateGreaterEqual: 'filter[orderCreationDate.gte]',
  orderDateLessEqual: 'filter[orderCreationDate.lte]',
  searchQuery: 'search[query]',
  shipToLocationId: 'filter[shipTo.id.equals]',
  sort: 'sort',
  status: 'filter[status.in]',
  updatedDateGreaterEqual: 'filter[lastUpdateDate.gte]',
  updatedDateLessEqual: 'filter[lastUpdateDate.lte]',
  userName: 'filter[user.name.icontains]',
}

export const orderFilterTranslationMap = {
  orderDate: getLocalizedDateFilter,
  requestedDeliveryDate: getLocalizedDateFilter,
  sort: getLocalizedSorting,
  status: getLocalizedOrderStatus,
  updated: getLocalizedDateFilter,
}

export type OrderFilters = typeof OrderFilter
export type OrderFilterKey = keyof OrderFilters
export type OrderFilterFnKey = keyof typeof orderFilterTranslationMap

export const orderFilterDefaults = {
  page: '1',
  sort: '-lastUpdateDate',
}
export interface OrderFilterOption {
  id: OrderFilterKey
  label: string
}
